import React from "react";
import { Box, Typography } from "@mui/material";

type LabelValueProps = {
    label: string;
    value: string | number;
    good?: boolean;
};

const LabelValueBox: React.FC<LabelValueProps> = ({ label, value, good = true }) => {
    return (
        <Box display="flex" flexDirection="column" mb={1}>
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
            >
                {label}
            </Typography>
            <Typography
                variant="h6"
                color="text.primary"
                sx={{ fontWeight: 600, color: good? "text.primary" : "error.main" }}
            >
                {value}
            </Typography>
        </Box>
    );
};

export default LabelValueBox;